// Leading zeros, keeping at least one character (so "000" becomes "0").
const LEADING_ZEROS = /^0+(?=.)/;

/**
 * Normalizes a device serial number for comparison. The same serial reaches
 * the frontend in different shapes: as a number (parsed NVG tasks), zero
 * padded (task metadata pads it to 6 digits, the equipment list to 19) or as
 * a plain string (device registry and Agrirouter onboardings).
 */
export function normalizeSerialNumber(serialNumber: unknown): string {
  if (serialNumber === null || serialNumber === undefined) {
    return '';
  }
  return String(serialNumber).trim().replace(LEADING_ZEROS, '');
}

/** Whether two serial numbers identify the same device. */
export function isSameSerialNumber(first: unknown, second: unknown): boolean {
  const normalizedFirst = normalizeSerialNumber(first);
  return (
    normalizedFirst !== '' && normalizedFirst === normalizeSerialNumber(second)
  );
}
